angular.module('dpw.services')

    .factory('freeTierService', ['tierIds', function (tierIds) {
        return {

            /**
             * Check if the user is using a free account.
             *
             * @deprecated
             * @param {Object} user - Profile data for the user account.
             * @returns {Boolean}
             */
            isFreeAccount: function (user) {
                var userTierId = _.get(user, 'servicePlanId');
                return _.includes(tierIds.free, userTierId);
            },

            signUp: {
                setResult: function (isSuccessful, data) {
                    isSuccessful = isSuccessful === true;
                    this.result = {isSuccessful: isSuccessful};
                    _.assign(this.result, data);
                },
                getResult: function () {
                    var result = this.result;
                    delete this.result;
                    return result;
                }
            }

        };
    }])

;
